import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-header"},[_c('div',{staticClass:"header-slot left"},[_c(VBtn,{attrs:{"icon":"","color":"graydark"},on:{"click":function($event){return _vm.$emit('click')}}},[_c(VIcon,[_vm._v("menu_open")])],1),_c('router-link',{attrs:{"to":{ path: '/' }}},[_c('div',{staticClass:"brand"})])],1),_c('div',{staticClass:"header-slot right"},[_vm._t("buttons"),_c('div',{staticClass:"avatar"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }